/*
Copyright (c) 2012-2022 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import {
  PLACEHOLDER_DASH,
  TransactionType,
  TransactionCategory,
  TransactionStatus,
} from "../../constants/misc"

export class Transaction {
  constructor(
    public readonly createdTime: Timestamp,
    public readonly updatedTime: Timestamp,
    public readonly storeID: StoreID,
    public readonly transactionID: TransactionID,
    public readonly longOrderID: LongOrderID,
    public readonly shortOrderID: ShortOrderID,
    public readonly transactionType: string,
    public readonly transactionCategory: string,
    public readonly amount: PriceInMin,
    public readonly status: string,
    public readonly payMethod: string,
    public readonly description: string,
    public readonly revenue: PriceInMin,
    public readonly tax: PriceInMin,
  ) {
    this.description =
      this.isAdsTransaction && this.isSuccessful
        ? description
        : PLACEHOLDER_DASH
    this.revenue =
      this.isAdsTransaction && this.isSuccessful
        ? revenue
        : Number.NaN
    this.tax =
      this.isAdsTransaction && this.isSuccessful
        ? tax
        : Number.NaN
  }

  get isMPANonOrder(): boolean {
    return (
      this.transactionType ===
        TransactionType.mpaType &&
      this.payMethod === PLACEHOLDER_DASH
    )
  }

  get isAdsTransaction(): boolean {
    return (
      this.transactionCategory ===
      TransactionCategory.adsType
    )
  }

  get isSuccessful(): boolean {
    return (
      this.status === TransactionStatus.success
    )
  }
}
